export default __webpack_public_path__ + "static/media/atrophy.d2c67085.png";